const { timers } = require('jquery');

/* Enable hover functionality on the large Global Goals icon on the front page on desktop devices */
class ProfetGlobalGoalsIcon {
	constructor() {
		this.slices = document.querySelectorAll('#global-goals-logo path[data-goal-number]');
		this.defaultBackground = '#016cb8';
		this.header = document.querySelector('.front-page-header');
		this.goalTitle = document.querySelector('.front-page-header .goal-title');
		this.floatingLogoContainer = document.querySelector('.floating-logo-container');
		this.floatingLogoImage = document.querySelector('.floating-logo-container img');
		this.goalsData = [];
		this.mouseCoords = {
			x: 0,
			y: 0,
		};
		this.changeBackgroundTimeout = false;
		this.slicesTransitionTimeout = false;
		this.init();
	}

	init() {
		if (!this.slices || !this.header) {
			return;
		}
		this.setupGoalsData();
		this.setupEvents();
	}
	setupGoalsData() {
		let data = this.header.getAttribute('data-goals');
		if (!data) {
			return;
		}
		this.goalsData = JSON.parse(data);
	}
	trackMousePosition() {}
	setupEvents() {
		for (let i = 0; i < this.slices.length; i++) {
			let goalData = this.goalsData.find((goal) => {
				return goal.number == this.slices[i].getAttribute('data-goal-number');
			});

			this.slices[i].addEventListener('mousemove', (event) => {
				/* Set the mouse coordinates */
				this.mouseCoords = {
					y: event.clientY,
					x: event.clientX,
				};
				this.floatingLogoContainer.style.top = `${this.mouseCoords.y - 170}px`;
				this.floatingLogoContainer.style.left = `${this.mouseCoords.x}px`;
			});

			this.slices[i].addEventListener('mouseenter', (event) => {
				clearTimeout(this.changeBackgroundTimeout);
				clearTimeout(this.slicesTransitionTimeout);
				let fill = event.target.getAttribute('fill');
				//this.header.style.backgroundColor = fill;
				this.header.classList.add('hovered');
				this.header.classList.add('active');
				this.floatingLogoContainer.classList.add('show-logo');
				this.floatingLogoImage.src = goalData.logoUrl;
			});
			this.slices[i].addEventListener('mouseleave', (event) => {
				this.changeBackgroundTimeout = setTimeout(() => {
					this.header.style.backgroundColor = this.defaultBackground;
					this.header.classList.remove('hovered');
				}, 1200);
				this.slicesTransitionTimeout = setTimeout(() => {
					this.header.classList.remove('active');
				}, 500);
				this.floatingLogoContainer.classList.remove('show-logo');
			});
			this.slices[i].addEventListener('click', (event) => {
				window.location.href = goalData.link;
			});
		}
	}
}

window.addEventListener('load', () => {
	window.globalGoalsIcon = new ProfetGlobalGoalsIcon();
});
